module.exports = __webpack_public_path__ + "img/anli1.e8d6190c.jpg";